/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Return_ToInputs */

const en_mcp_connect_return_to = /** @type {(inputs: Mcp_Connect_Return_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Return to ${i?.app}`)
};

const es_mcp_connect_return_to = /** @type {(inputs: Mcp_Connect_Return_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volver a ${i?.app}`)
};

/**
* | output |
* | --- |
* | "Return to {app}" |
*
* @param {Mcp_Connect_Return_ToInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_return_to = /** @type {((inputs: Mcp_Connect_Return_ToInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Return_ToInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_return_to(inputs)
	return en_mcp_connect_return_to(inputs)
});